import { TransactionPreview } from '../../../model/myria/app/transactionPreview';
import { LoginProvider } from '../login-provider';
import { HttpMapper } from '../http-mapper';
import { Injectable } from '@angular/core';
import { Transaction, TRANSACTION_CATEGORY_TYPE, TransactionInfo, TransactionV3, TransactionViewType, TransactionReportAPIInfo } from '../../../model/myria/app/transaction';
import { Beneficiary } from '../../../model/myria/app/beneficiary';
import { Observable } from 'rxjs';
import { UtilsProvider } from '../utils-provider';
import { map } from 'rxjs/operators';
import { CustomerProviderMapperProvider } from './customer-provider-mapper';
import { APP_CONFIG, Region } from '../../../environment';
import { HttpProvider } from '../../http/http';
import { LoggerProvider, LoggerEvent } from '../../logger/logger';
import { IPromotions } from '../../../model/models/promotions.interface';
import { IOrder } from '../../../model/models/order/order-interface';
import { SegmentLocationNames } from '../../../model/types/analytics.const';
import { RecentRecipients } from '../../../model/api/recipients/recent-recipients.entity.interface';
import { LoginPasswordType } from '../../../model/models/register/user-register';
import { RegisterProvider } from '../../../providers/register/register';
import { StorageProvider } from '../../../providers/storage/storage';
import { RecentRateEntity } from '../../../model/api/recent-rate.entity.interface';
import { OrderMapper } from '../../order/order.mapper';
import { DeliveryMethodType } from '../../../model/types/delivery-method-type';

@Injectable()
export class CustomersProvider {
  beneficiaries = {};
  transactions: Transaction[] = null;
  transactionsv2: Transaction[] = null;
  transactionsCondensed: Transaction[] = null;
  transactionsInfo: TransactionInfo = null;
  recentRecipients: RecentRecipients;
  checkForAppStoreReview = false;
  showAppStoreReview = false;
  isTransactionalNPSNeeded = false;
  lastTransactionRate: RecentRateEntity = null
  transactionPromise: Promise<Transaction[]>;

  constructor(public http: HttpMapper,
              public loginProvider: LoginProvider,
              public utils: UtilsProvider,
              private httpProvider: HttpProvider,
              private registerProvider: RegisterProvider,
              private storageProvider: StorageProvider) {
    this.logout();
  }

  logout() {
    this.transactions = null;
    this.transactionsv2 = null;
    this.transactionsCondensed = null;
    this.transactionsInfo = null;
    this.recentRecipients = null;
    this.checkForAppStoreReview = false;
    this.showAppStoreReview = false;
    this.isTransactionalNPSNeeded = false;
    this.lastTransactionRate = null;
    this.transactionPromise = null;
  }

  initBeneficiaries(): void {
    this.beneficiaries = {};
  }

  getBeneficiaries(): Observable<Beneficiary[]> {
    let customerId = this.httpProvider.getAuthCustomerId();
    return this.http.get(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/Beneficiaries').pipe(map(json => {
      this.beneficiaries[customerId] = json as Beneficiary[];
      return this.beneficiaries[customerId];
    }));
  }

  getLastTransaction(){
    if (this.transactionsv2 && this.transactionsv2.length > 0)
      return this.transactionsv2[0];
    else if (this.transactions && this.transactions.length > 0)
      return this.transactions[0];
    else if (this.transactionsCondensed && this.transactionsCondensed.length > 0)
      return this.transactionsCondensed[0];
    else
      return null;
  }

  getLastTransactions(){
    if (this.transactionsv2)
      return this.transactionsv2;
    else if (this.transactions)
      return this.transactions;
    else if (this.transactionsCondensed)
      return this.transactionsCondensed;
    else
      return null;
  }

  getTransactions(page: number, params: any): Observable<Transaction[]> {
    let data = Object.assign({}, params);
    data.Page = page;
    return this.http.post(`${APP_CONFIG.API_URL}api/Customers/${this.httpProvider.getAuthCustomerId()}/Transactions`, data).pipe(map(json => json as Transaction[]));
  }

  getTransactionsByPromise(): Promise<Transaction[]> {
    return new Promise((resolve, reject) => {
      if(this.transactions) resolve(this.transactions);
      else {
        this.http.post(`${APP_CONFIG.API_URL}api/Customers/${this.httpProvider.getAuthCustomerId()}/Transactions`, {Page: 0}).subscribe(res => {
          this.transactions = res;
          resolve(this.transactions);
        },
        err => reject(err));
      }
    });
  }

  async getRecentTransactionGroupByStatus(forceReload: boolean = true): Promise<RecentRecipients> {
    if (!forceReload && this.recentRecipients)
      return this.recentRecipients;
    this.recentRecipients = await this.http.get(APP_CONFIG.API_URL +'api/Customer/distinct-recent-recipients?RecipientQuantity=4').toPromise();
    return this.recentRecipients;
  }

  async getTransactionsGroupedByStatus(page: number,query: String = null, forceReload: boolean = true, viewType = TransactionViewType.Full): Promise<Transaction[]> {

    if(!forceReload && page === 0) {
      if ((viewType === TransactionViewType.Condensed || viewType === TransactionViewType.Any) && this.transactionsCondensed)
        return(this.transactionsCondensed);
      else if ((viewType === TransactionViewType.Full || viewType === TransactionViewType.Any) && this.transactionsv2)
        return(this.transactionsv2);
    }

    let checkForAppStoreReviewElibility = false;
    if (this.checkForAppStoreReview && page === 0) {
      LoggerProvider.info(this, 'Check for app store review in transactions');
      checkForAppStoreReviewElibility = true;
      this.checkForAppStoreReview = false;
    }
    try {
      LoggerProvider.info(this, `Load transactions (view type: ${viewType}, force reload: ${forceReload})`)
      let condensed = false;
      if (viewType === TransactionViewType.Condensed || viewType === TransactionViewType.Any)
        condensed = true;

      // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!
      this.transactionPromise = this.http.post(APP_CONFIG.API_URL + 'api/Customers/' + this.httpProvider.getAuthCustomerId() + '/v3/Transactions', {Page: page, 'filterQuery': query, 'condensed': condensed, 'CheckForAppStoreReview': checkForAppStoreReviewElibility }).toPromise();
      const transactions: any = await this.transactionPromise;
      this.transactionPromise = null;
      if (condensed)
        this.transactionsCondensed = transactions.Transactions;
      else if (page === 0) {
        // only cache page 0 to avoid overriding transactionsv2 with empty transactions page
        this.transactionsv2 = transactions.Transactions;
        this.transactionsCondensed = this.transactionsv2 ? this.transactionsv2.slice(0, 4) : null;
        if (typeof(transactions.TotalTransactionCount) !== 'undefined' && typeof(transactions.FirstTransaction) !== 'undefined') {
          this.transactionsInfo = {
            transactions: transactions.Transactions ? transactions.Transactions : [],
            filteredTransactions: transactions.FilteredTransactions ? transactions.FilteredTransactions : [],
            totalTransactionCount: transactions.TotalTransactionCount,
            isFirstTransaction: transactions.FirstTransaction,
            NonCanceledFirstTransaction: transactions.NonCanceledFirstTransaction ? transactions.NonCanceledFirstTransaction : false
          };
        } else {
          this.transactionsInfo = {
            transactions: transactions.Transactions ? transactions.Transactions : [],
            filteredTransactions: [],
            totalTransactionCount: transactions.Transactions.length ? transactions.Transactions.length : 0,
            isFirstTransaction: transactions.Transactions ? (transactions.Transactions.length === 0) : true,
            NonCanceledFirstTransaction: transactions.NonCanceledFirstTransaction ? transactions.NonCanceledFirstTransaction : false
          };
        }
      }

      if (checkForAppStoreReviewElibility) {
        if(transactions.AppReviewEligibiliy)
          this.showAppStoreReview = transactions.AppReviewEligibiliy.Eligible;
        if (this.showAppStoreReview)
          LoggerProvider.info(this, 'Is eligible for app store review');
        else
          LoggerProvider.info(this, 'Is not eligible for app store review');
      }
      this.isTransactionalNPSNeeded = false;
      if (transactions && transactions.IsTransactionalNPSNeeded)
        this.isTransactionalNPSNeeded = transactions.IsTransactionalNPSNeeded === true;
      this.mapTransactions(transactions);
      return transactions.Transactions;
    } catch(ex) {
      if (checkForAppStoreReviewElibility)
        this.checkForAppStoreReview = true;
      LoggerProvider.exception(this, ex, LoggerEvent.TransactionLoad, "Couldn't get Transactions Grouped By Status")
    }
  }

  async getTransactionInfo(forceReload: boolean = false): Promise<TransactionInfo> {
    await this.getTransactionsGroupedByStatus(0, null, forceReload);
    return this.transactionsInfo;
  }

  async getTransactionsGroupedByStatusV3(page: number,query: String = null, checkForAppStoreReviewElibility: boolean = false): Promise<TransactionV3> {
    // optional filter query
    if (query == null) query = "";
    if (checkForAppStoreReviewElibility) {
      LoggerProvider.info(this, 'Check for app store review in transactions V3');
      this.checkForAppStoreReview = false;
    }
    const transactions = await this.http.post(APP_CONFIG.API_URL + 'api/Customers/' + this.httpProvider.getAuthCustomerId() + '/v3/Transactions', {Page: page, 'filterQuery': query, 'CheckForAppStoreReview': checkForAppStoreReviewElibility}).toPromise();
    if (checkForAppStoreReviewElibility) {
      if(transactions.AppReviewEligibiliy) {
        this.showAppStoreReview = transactions.AppReviewEligibiliy.Eligible;
      }
    }
    this.isTransactionalNPSNeeded = false;
    if (transactions && transactions.IsTransactionalNPSNeeded)
      this.isTransactionalNPSNeeded = transactions.IsTransactionalNPSNeeded === true;
    this.mapTransactions(transactions);
    return transactions;
  }

  getTransaction(transactionId: number): Observable<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    return this.http.get(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/Transactions/' + transactionId);
  }

  getNewTransactionPreview (transaction: any): Observable<TransactionPreview> {
    return this.http.post(APP_CONFIG.API_URL + 'api/NewTransactionPreview', transaction);
  }

  orderConfirm(order: IOrder, statusOnHold?: boolean, veracityDisclosure?: boolean, isValidate?: boolean, acceptsTermsAndConditions?: boolean, fetchRequiredFields: boolean = false): Observable<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    let confirm = CustomerProviderMapperProvider.orderToOrderConfirm(order, statusOnHold, veracityDisclosure, isValidate, acceptsTermsAndConditions,fetchRequiredFields)
    return this.http.put(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/NewTransaction', confirm);
  }

  releasePromotion(transIdLocked: any): Observable<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    return this.http.delete(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/Moneytransfer/Promotions/Reservations/' + transIdLocked);
  }

  getOfferedDeliveryMethods(countryId: number, customerId: number): Observable<any> {
    return this.http.get(APP_CONFIG.API_URL + 'api/Customer/' + customerId + '/CountryTo/' + countryId + '/OfferedDeliveryMethods');
  }

  getUpdateCustomerFormFields(): Observable<any> {
    return this.http.get(APP_CONFIG.API_URL + 'api/Customer/UpdateIdentitiDocumentRequiredFields');
  }

  public submitOCRForm(data: any, marketingConsent: boolean): Observable<any> {
    return this.http.put(APP_CONFIG.API_URL + 'api/Customer?enableMarketingPushNotifications=' + marketingConsent, data);
  }

  public createNewCustomer(data: any, marketingConsent: boolean): Observable<any> {
    return this.http.put(APP_CONFIG.API_URL + 'api/Customer/CreateCustomerOnfido?enableMarketingPushNotifications=' + marketingConsent, data);
  }

  requestUpdateCustomerEmail(email: string): Promise<any> {
    let data = {
      "emailAddress": email
    }
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}customer-profile/request-email-address-update`, data)
  }

  updateCustomer(customerId: number, data: any, marketingConsent: boolean): Observable<any> {
    return this.http.post(APP_CONFIG.API_URL + 'api/Customer/' + customerId + '?enableMarketingPushNotifications=' + marketingConsent, data);
  }

  updateCustomerV2(customerId: number, data: any): Observable<any> {
    return this.http.put(APP_CONFIG.API_URL + 'api/Customer/v2/' + customerId, data);
  }

  requestTransactionReport(email: string, fromDate: string, toDate: string, checkAvailability: boolean): Promise<TransactionReportAPIInfo> {
    let data: any;
    const customerId = this.httpProvider.getAuthCustomerId();

    if (checkAvailability) {
      data = {
        CheckPendingRequest: true,
      };
    } else {
      data = {
        EmailTo: email,
        DateBegin: fromDate,
        DateEnd: toDate,
        CheckPendingRequest: false,
      };
    }

    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/Certificates/Customers/' + customerId + '/SendingCertificate', data);
  }

  async validateOTP(securityCode: string, referenceValue: string, OTPAction: number, OTPCode: string, deliveryType: number): Promise<any> {
    const mfaDeviceToken = await this.loginProvider.getMfaDeviceToken();
    let data = {
      'securityCode': securityCode,
      'referenceValue': referenceValue,
      'action': OTPAction,
      'code': OTPCode,
      'DeliveryType': deliveryType,
      "DeviceId": LoggerProvider.uuid, // is like this.device.uuid but also supports a virtual uuid for browsers
      "DeviceSimCard": mfaDeviceToken
    };
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/OTP/v2/Validate', data);
  }

  async validateLoginOTP(securityCode: string, OTPAction: number, OTPCode: string, deliveryType: number, sessionKey?: string): Promise<any> {
    const mfaDeviceToken = await this.loginProvider.getMfaDeviceToken();
    let data = {
      'securityCode': securityCode,
      'sessionKey': sessionKey,
      'action': OTPAction,
      'code': OTPCode,
      "DeviceId": LoggerProvider.uuid, // is like this.device.uuid but also supports a virtual uuid for browsers
      "DeviceSimCard": mfaDeviceToken,
      'DeliveryType': deliveryType,
    };

    if(APP_CONFIG.region.region === Region.SN) data['LoginType'] = LoginPasswordType.PIN // for SN need to pass PIN to validate otp

    let url = APP_CONFIG.API_URL + 'api/Auth/V3/ValidateOtp';
    if (APP_CONFIG.featureFlags.signinOld)
      url = APP_CONFIG.API_URL + 'api/Auth/ValidateOtp';
    return this.httpProvider.post(url, data);
  }

  async mobileVerify(Phone: string, OTPAction: number): Promise<any> {
    const mfaDeviceToken = await this.loginProvider.getMfaDeviceToken();
    let data = {
      'action': OTPAction,
      "DeviceId": LoggerProvider.uuid, // is like this.device.uuid but also supports a virtual uuid for browsers
      "DeviceSimCard": mfaDeviceToken
    };
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/OTP/Resource/' + Phone, data);
  }

  async mobileVerifyV2(Phone: string, OTPAction: number): Promise<any> {
    let data = {
      'action': OTPAction,
      'DeliveryType': SegmentLocationNames.SmsPhoneVerification
    };
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/OTP/Resource/' + Phone, data);
  }

  async validationUpdatePhone(securityCode: string, referenceValue: string, OTPAction: number, OTPCode: string, ResourceType: number): Promise<any> {
    const mfaDeviceToken = await this.loginProvider.getMfaDeviceToken();
    let data = {
      'securityCode': securityCode,
      'referenceValue': referenceValue,
      'action': OTPAction,
      'code': OTPCode,
      'Resource': referenceValue,
      'ResourceType': ResourceType, //int (10 email, 20 telefono),
      "DeviceId": LoggerProvider.uuid,
      "DeviceSimCard": mfaDeviceToken
    }
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/Account/ConfirmResourceUpdate`, data);
  }

  async validationUpdatePhoneV2(securityCode: string, referenceValue: string, OTPAction: number, OTPCode: string, ResourceType: number): Promise<any> {
    const mfaDeviceToken = await this.loginProvider.getMfaDeviceToken();
    let data = {
      'securityCode': securityCode,
      'referenceValue': referenceValue,
      'action': OTPAction,
      'code': OTPCode,
      'Resource': referenceValue,
      'ResourceType': ResourceType, //int (10 email, 20 telefono)
      "DeviceId": LoggerProvider.uuid,
      "DeviceSimCard": mfaDeviceToken
    }
    if(this.registerProvider.isPINOnlyRegLoginCountry){
      const tokenReference = await this.storageProvider.getSetUserTokenReference(false)
      data['TokenReference'] = tokenReference;
    }
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/Account/v2/ConfirmResourceUpdate`, data);
  }

  async getCustomerPromotions(): Promise<IPromotions> {
    let customerId = this.httpProvider.getAuthCustomerId();
    return this.http.get(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/Moneytransfer/Promotions').toPromise();
  }

  async getLRUserPromotions(): Promise<IPromotions> {
    return this.http.get(APP_CONFIG.API_URL + 'api/Users/Moneytransfer/Promotions').toPromise();
  }

  async addPromotion(promoCode: string, countryTo?: string): Promise<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    const url = countryTo ? '?countryTo=' + countryTo : '';
    return this.http.put(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/Moneytransfer/' + encodeURIComponent(promoCode) + '/Promotions' + url, {}).toPromise();
  }

  async addLRPromotion(promoCode: string): Promise<any> {
    return this.http.put(APP_CONFIG.API_URL + 'api/Users/Moneytransfer/Promotions/' + encodeURI(promoCode) ,{}).toPromise();
  }

  async getComplianceQuestions(params: any): Promise<any> {
    return this.http.post(APP_CONFIG.API_URL + 'api/Customer/ComplianceQuestions', params).toPromise();
  }

  async saveComplianceQuestions(params: any): Promise<any> {
    return this.http.post(APP_CONFIG.API_URL + 'api/Customer/ComplianceQuestions/save', params).toPromise();
  }

  async getCustomerRecentRate(forceLoad: boolean = false): Promise<RecentRateEntity> {
    if(!forceLoad && this.lastTransactionRate )
      return this.lastTransactionRate

    try {
        const rate = await this.http
          .get(`${APP_CONFIG.API_URL}api/LastTransactionRate`)
          .toPromise();
        this.lastTransactionRate = rate;
        return rate;
    } catch (error) {
        LoggerProvider.exception(this, error, LoggerEvent.LastTransactionRate, "Failed to fetch recent transaction rate.")
        throw error;
    }
  }

  async abortTransaction(params: any): Promise<any> {
    let customerId = this.httpProvider.getAuthCustomerId();
    let confirm = CustomerProviderMapperProvider.orderToOrderConfirm(params, false, true, true, true)
    return this.http.post(APP_CONFIG.API_URL + 'api/Customers/' + customerId + '/AbortTransaction', confirm).toPromise();
  }

  async isFirstTransaction(){
    let previousTransactionExists = false;
    if(!this.loginProvider.isLiteUser()){
      let transactionInfo = await this.getTransactionInfo();
      if(transactionInfo && transactionInfo.NonCanceledFirstTransaction){
        previousTransactionExists = transactionInfo.NonCanceledFirstTransaction;
      }
    }
    return !previousTransactionExists;
  }

  containsPaidTransaction(verifyTransactions) {
    const completedTransactions = verifyTransactions.filter((item) => item.OrderStatusCategory === TRANSACTION_CATEGORY_TYPE.MONEY_RECEIVED);
    if(completedTransactions && completedTransactions.length > 0){
      return true;
    }
  }

  hasFullTransactions() {
    if (this.transactionsv2)
      return true;
    return false;
  }

  async hasPaidTransaction(forceReload = false){
    // for best performance first check if we already have condensed transactions and maybe they contain already a paid transaction then we don't have to dig deeper
    if (this.transactionsCondensed) {
      if (this.containsPaidTransaction(this.transactionsCondensed)) {
        LoggerProvider.info(this, 'Has paid transactions already in condensed transactions');
        return true;
      }
    }

    // then check if we already have the transactions if there are paid - even when forceReload is set it hence may not be needed
    if (this.transactionsv2) {
      if (this.containsPaidTransaction(this.transactionsv2)) {
        LoggerProvider.info(this, 'Has paid transactions already in cached transactions');
        return true;
      }
    }

    // otherwise if we didn't have transactions yet or if forceReload is enabled and we had transactions but they were not paid look for the latest ones
    if (!this.transactionsv2 || forceReload) {
      const transactions = await this.getTransactionsGroupedByStatus(0, null, true, TransactionViewType.Full);
      if (transactions) {
        if (this.containsPaidTransaction(transactions)) {
          LoggerProvider.info(this, 'Has paid transactions after loading');
          return true;
        }
      }
    }

    LoggerProvider.info(this, 'Has no paid transactions');
    return false;
  }

  mapTransactions(transactions) {
    if (transactions && transactions.Transactions) {
      transactions.Transactions.forEach((transaction) => {
        if (transaction.DelivMethod === DeliveryMethodType.BANK_DEPOSIT_NUM_CODE  && OrderMapper.isDirectDebitPayoutAgent(transaction.PayAgentId)) {
          transaction.DelivMethod = DeliveryMethodType.DEBIT_CARD_NUM_CODE;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/myria/customer-provider/customers-provider.ts